'use client'

import { type ReactNode } from 'react'

import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import { useClickAction } from '@src/hooks/useClickAction/useClickAction'
import {
  type ActionName,
  type AnalyticsEvents,
} from '@src/hooks/useClickAction/useClickAction.builder'
import { type UseClickActionArgs } from '@src/hooks/useClickAction/useClickActionArgs'
import { filterBuilderAttributes, getBuilderPreviewMode } from '@src/utils/builder.util'
import { cn } from '@src/utils/tailwind'

export type ActionLinkProps = UseClickActionArgs & {
  actionName?: ActionName
  analyticsEvent?: (typeof AnalyticsEvents)[number]
  children?: ReactNode
  className?: string
}

export const ActionLink = (props: ActionLinkProps) => {
  const { children, attributes } = props
  const { edit } = getBuilderPreviewMode()
  const { renderVideo, handlers } = useClickAction(props)

  const actionName = props.actionName
  const isWrapping = actionName === 'navigate'

  const divButtonProps =
    !isWrapping && actionName && actionName !== 'none'
      ? {
          role: 'button',
          tabIndex: 0,
        }
      : {}

  return (
    <div
      className={cn(
        'cursor-pointer',
        { 'border-4 border-dotted border-sky-500': edit },
        props.className
      )}
    >
      {isWrapping ? (
        <LocalizedLink
          {...filterBuilderAttributes(attributes)}
          {...handlers}
          href={props.navigate?.href ?? ''}
          target={props.navigate?.target}
        >
          {children}
        </LocalizedLink>
      ) : (
        <div {...divButtonProps} {...handlers}>
          {children}
        </div>
      )}
      {renderVideo()}
    </div>
  )
}
